const STATUS_ROW_TYPE = Object.freeze({
  Success: 'success',
  Info: 'info',
  Error: 'error',
});

export { STATUS_ROW_TYPE };
